import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/app/catalog/CatalogContent.tsx");
